import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {ClassEnergetiqueEnum} from '../../pages/rt2012/parametrage-usages/enums/ClassEnergetiqueEnum';

@Component({
    selector: 'app-note-energie',
    templateUrl: './note-energie.component.html',
    styleUrls: ['./note-energie.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NoteEnergieComponent implements OnInit {

  ClassEnergetiqueEnum = ClassEnergetiqueEnum;

  @Input() selectable = true;
  @Input() value: ClassEnergetiqueEnum = null;

  @Output() changed: EventEmitter<ClassEnergetiqueEnum> = new EventEmitter();
  selecting = false;

  constructor() {
  }

  radioChanged(classEnergetiqueEnum: ClassEnergetiqueEnum): void {
    this.changed.emit(classEnergetiqueEnum);
    this.selecting = false;
  }

  ngOnInit(): void {
    if (this.value === null) {
      setTimeout(() => {
        this.value = ClassEnergetiqueEnum.CLASSE_ENERGETIQUE_INCONNUE;
        this.changed.emit(this.value);
      });
    }
  }

  hide() {
    this.selecting = false;
  }
}
